import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { T } from "../../constants";

/* ---------- Label / value row used inside offsite dialogs ---------- */

const useStyles = makeStyles({
  row: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: 12,
    padding: "6px 0",
    borderBottom: `1px solid ${T.borderSoft}`,
    "&:last-child": { borderBottom: "none" },
  },
  label: { fontSize: 11, textTransform: "uppercase", letterSpacing: 0.5, color: T.subtleFg },
  value: { fontSize: 14, color: T.fg, textAlign: "right" },
});

export default function DialogRow({ label, children }) {
  const s = useStyles();
  return (
    <div className={s.row}>
      <span className={s.label}>{label}</span>
      <span className={s.value}>{children}</span>
    </div>
  );
}
